import { render } from "./dashSkillView.vue?vue&type=template&id=27b1d386"
import script from "./dashSkillView.vue?vue&type=script&lang=js"
export * from "./dashSkillView.vue?vue&type=script&lang=js"

import "./dashSkillView.vue?vue&type=style&index=0&id=27b1d386&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__